import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Checkbox } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import BorderColorIcon from "@mui/icons-material/BorderColor";

const useColumns = (
  setViewProduct,
  setProduct,
  handleViewOpen,
  handleModalOpen
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowData, setActiveRowData] = useState(null);

  const handleMenuOpen = (event, data) => {
    setAnchorEl(event.currentTarget);
    setActiveRowData(data);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowData(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const columns = [
    {
      Header: "",
      accessor: "checkbox",

      disableSortBy: true,
      Cell: ({ row }) => (
        <Checkbox
          checked={selected[row.values.id] || false}
          onChange={() => handleCheckboxChange(row.values.id)}
        />
      ),
    },
    {
      Header: "",
      accessor: "expand",

      disableSortBy: true,
      Cell: ({ row }) =>
        row.values.actions ? (
          <IconButton onClick={() => row.toggleRowExpanded()}>
            <ExpandMoreIcon />
          </IconButton>
        ) : null,
    },
    {
      Header: "รูปภาพ",
      accessor: "picture",
      disableSortBy: true,
      width: "143px",
    },
    { Header: "รหัสสินค้า", accessor: "product_code" },
    { Header: "ชื่อสินค้า", width: "200px", accessor: "product_name" },
    { Header: "จำนวน", width: "200px", accessor: "total_amount" },
    { Header: "หมวดหมู่สินค้า", width: "200px", accessor: "category" },
    { Header: "ราคาทุน", width: "200px", accessor: "price" },
    { Header: "ราคาขาย", width: "200px", accessor: "sell_price" },
    { Header: "วันที่สร้าง", width: "200px", accessor: "created_date" },
    { Header: "ชื่อร้านค้า/บริษัท", width: "200px", accessor: "company_name" },
    { Header: "สถานะ", width: "200px", accessor: "product_type" },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      Cell: ({ row }) => (
        <div>
          <IconButton onClick={(event) => handleMenuOpen(event, row)}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem
              onClick={() => {
                setViewProduct(activeRowData);
                handleViewOpen();
                handleMenuClose();
              }}
            >
              <RemoveRedEyeIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />

              <span style={{ marginLeft: "8px", color: "#737373" }}>
                ดูรายละเอียด
              </span>
            </MenuItem>
          </Menu>
        </div>
      ),
    },
  ];

  return columns;
};

export default useColumns;
